// extracted by mini-css-extract-plugin
export default {"contactCard":"styles_contactCard__g8UTT","info":"styles_info__eI64M","title":"styles_title__ohwD5","subtitle":"styles_subtitle__3gT-O","summary":"styles_summary__OkI9V"};